import React, { Component } from 'react';
import Wrapper from './style';

import Collateralize from '../../components/Collateralize';
import Pledge from '../../components/Pledge';
import SuccessCollateralized from '../../components/SuccessCollateralized';
import Comments from '../../components/Comments';
import Flag from '../../components/Flag';
import ModalForm from './ModalForm';

import {
	getPublicCollateral,
	getCollateral,
	withdrawXht,
	pledgeXht,
	getExchangeMsg,
	postExchangeMsg,
	deleteExchangeMsg,
	putExchange,
	uploadImage,
	getStakeAll
} from '../../common/fetch';
import { message, Modal, Icon, Tabs } from 'antd';
import {
	// returnDate,
	getCountry
} from '../../common/utils';
import { EXCHANGE_S3_IMAGE, COLLATERAL_TOTAL_AMOUNT, API_URL } from '../../config/constants';

const { TabPane } = Tabs;

export const pickRandomImage = (id) => {
	const imageArray = ['url(/assets/img/public-projects-placeholder_1.png)', 'url(/assets/img/public-projects-placeholder_2.png)', 'url(/assets/img/public-projects-placeholder_3.png)'];
	let imageIndex = id % 10;
	imageIndex = Math.round(imageIndex / 3);
	return imageIndex === 3 ? imageArray[imageIndex-1] : imageArray[imageIndex]
}
class Project extends Component {
	state = {
		isLoaded: false,
		isOpen: false,
		isFinish: false,
		id: undefined,
		msgs: [],
		page: 1,
		cmtIsLoading: false,
		isCreator: false,
		isOpenForm: false,
		type: '',
		modalType: '',
		stakeData: [],
		isClosingPledge: false,
		isLoading: true
	};

	flexBox = null;

	componentDidMount() {
		const { location } = this.props;
		const arr = location.pathname.split('/');
		const id = arr[arr.length - 1];
		if (isNaN(id)) {
			message.error('This is Wrong page');
		} else {
			this.getData(id);
			this.getMessage(id);
		}
		this.getStakeAllData();
		this.getRemove();
	}

	componentDidUpdate(prevProps, prevState) {
		if (JSON.stringify(prevProps.collateral) !== JSON.stringify(this.props.collateral) ||
			prevState.id !== this.state.id
		) {
			this.getRemove();
		}
	}

	getRemove = () => {
		const { collateral } = this.props;
		const { pledgesAll = {} } = collateral
		const pledges = pledgesAll.pledges || [];
		const closingPledge = pledges.filter(pledge => pledge.exchange_id === this.state.id
			&& pledge.close_request !== null);
		this.setState({ isClosingPledge: !!closingPledge.length })
	}

	setRef = (el) => {
		this.flexBox = el;
	};

	getData = async (id) => {
		let res = {};
		if (this.props.user.id === 0) {
			try {
				res = await getPublicCollateral(id);
			} catch (error) {
				console.error(error);
				message.error('Failed to get Project Data.');
			}
		} else {
			try {
				res = await getCollateral(id);
			} catch (error) {
				console.error(error);
				message.error('Failed to get Project Data.');
			}
		}
		const { data = {} } = res;
		this.props.actions.setCollateral(data);
		this.setState({
			isLoaded: true,
			id: parseInt(id, 10),
			isCreator: parseInt(data.user_id) === parseInt(this.props.user.id)
		});
	};

	getMessage = (id) => {
		const { page } = this.state;
		this.setState(
			{
				cmtIsLoading: true
			},
			async () => {
				try {
					const res = await getExchangeMsg(id, page);
					const msgs = this.state.msgs.concat(res.data.data);
					this.setState({ msgs, page: page + 1, cmtIsLoading: false });
				} catch (error) {
					console.error(error);
				}
			}
		);
	};

	postMessage = async (msg) => {
		const body = { message: msg };
		try {
			const res = await postExchangeMsg(this.state.id, body);
			const msgs = [res.data].concat(this.state.msgs);
			this.setState({ msgs });
		} catch (error) {
			console.error(error);
			message.error('You need to login to comment a message');
		}
	};

	deleteMessage = async (id) => {
		try {
			await deleteExchangeMsg(this.state.id, id);
			message.success('Message is deleted');
			this.setState({
				msgs: this.state.msgs.filter((item) => item.id !== id)
			});
		} catch (error) {
			console.error(error);
		}
	};

	onWithdraw = (modalType) => {
		// const { collateral } = this.props;
		// if (collateral.is_collateralized) {
		// 	message.warn(
		// 		'Once the exchange is collateralized you can not withdraw your pledge for minimum of 6 months. You can read more here.'
		// 	);
		// 	return;
		// }
		// if (collateral.pledges.mine === 0) {
		// 	return;
		// }
		// Modal.confirm({
		// 	title: 'Withdraw Pledge',
		// 	content:
		// 		'You are about to with withdraw all of your pledged XHT. Are you sure you want to withdraw your pledge?" ',
		// 	onOk: () => {
		// 		this.backToWallet();
		// 	},
		// 	onCancel() {}
		// });
		this.setState({ modalType });
		this.openModal();
	};

	backToWallet = async () => {
		const { collateral, user } = this.props;
		const body = {
			exchange_id: collateral.id
		};
		try {
			await withdrawXht(body);
			const xht_available =
				parseFloat(user.balance.xht_available) +
				parseFloat(collateral.pledges.mine);
			this.props.actions.backCollateral(collateral.pledges.mine);
			this.props.userAction.updateData({ balance: { xht_available } });
			message.success('Your pledge is successfully withdrawn.');
		} catch (error) {
			console.error(error);
			message.error('Failed to withdraw pledge');
		}
	};

	handleChangeTab = (v) => {
		this.setState({ tabIdx: v });
	};

	pledgXht = async (body) => {
		const { user, userAction, actions, collateral } = this.props;
		try {
			await pledgeXht(body);
			const xht_available =
				parseFloat(user.balance.xht_available) - parseFloat(body.amount);
			const isFinish =
				parseFloat(COLLATERAL_TOTAL_AMOUNT) <= parseFloat(collateral.pledges.total);
			const states = {
				isOpen: false,
				isFinish
			};
			this.setState(states, () => {
				userAction.updateData({ balance: { xht_available } });
				actions.addCollateral(body.amount);
				if (isFinish) {
					Modal.info({
						title: 'Your pledge is done successfully.',
						content: () => (
							<p>
								<b>You've Pledged: </b> {body.amount} XHT
							</p>
						)
					});
				} else {
					actions.updateCollateral({
						amount: COLLATERAL_TOTAL_AMOUNT
					});
				}
			});
		} catch (error) {
			console.error(error);
			message.error('Failed to Pledge');
		}
	};

	updateExchange = async (data, type) => {
		const body = {
			id: this.props.collateral.id,
			is_public: true,
			info: {
				public: { ...this.props.collateral.info.public }
			}
		};
		switch (type) {
			case 'info':
				body.info.public.title = data.title;
				body.info.public.description = data.description;
				break;

			case 'banner':
				try {
					await this.handleChangeFile(data.banner);
					const file_name =
						window.location.host.indexOf('dash') < 0
							? 'testnet-banner'
							: 'banner';
					body.info.public.banner = EXCHANGE_S3_IMAGE(
						file_name,
						this.props.collateral.name
					);
				} catch (error) {
					console.error(error);
					message.error(
						'Failed to upload your image. Please try again.'
					);
					this.setState({ isOpenForm: false });
					return;
				}
				break;

			case 'pitch':
				body.info.public.usp = data.usp;
				body.info.public.risk = data.risk;
				body.info.public.operator = data.operator;
				body.info.public.timeline = data.timeline;
				break;

			default:
				break;
		}

		try {
			await putExchange(body);
			message.success('Successfully updated');
			this.props.actions.updateCollateral(body);
		} catch (error) {
			console.error(error);
			message.error('Failed to update info');
		}

		this.setState({ isOpenForm: false });
	};

	handleChangeFile = async (files) => {
		try {
			const formData = new FormData();
			const file_name =
				window.location.host.indexOf('dash') < 0
					? 'testnet-banner'
					: 'banner';
			await formData.append('exchange_name', this.props.collateral.name);
			await formData.append('file_name', file_name);
			await formData.append('file', files);

			await uploadImage(formData);
			return;
		} catch (error) {
			throw error;
		}
	};

	copy = (e) => {
		const copyText = e.target;
		/* Select the text field */
		if (copyText.tagName === 'INPUT') {
			copyText.select();
			copyText.setSelectionRange(0, 99999); /*For mobile devices*/

			/* Copy the text inside the text field */
			document.execCommand('copy');
			message.success('Copied!');
		}
	};

	openModal = () => {
		const { collateral } = this.props;
		if (collateral.is_collateralized) {
			return;
		}
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	hidePopup = () => {
		this.setState({ isFinish: false });
	};

	handlePledge = (modalType) => {
		const { user, history, location, collateral } = this.props;
		if (collateral.is_collateralized) {
			Modal.info({
				title: 'Exchange is already collateralized'
			});
		} else if (user.id === 0) {
			Modal.confirm({
				title: 'You need to Login',
				onOk: () => {
					const obj = {
						pathname: '/login',
						state: {
							project: location.pathname
						}
					};
					history.push(obj);
				}
			});
		} else {
			this.setState({ isOpen: true, modalType });
		}
	};

	getStakeAllData = async () => {
		try {
			this.setState({ isLoading: true });
			const res = await getStakeAll();
			this.props.updateCollateral({ pledgesAll: res.data })
			const stakeData = [...res.data.pledges];
			this.setState({ stakeData, isLoading: false });
		} catch (error) {
			console.error(error);
			this.setState({ isLoading: false });
		}
	};

	renderPopup = () => {
		const { isOpen, modalType, stakeData } = this.state;
		const { collateral, exchange } = this.props;
		const filterData = stakeData.filter(data => data.exchange_id === collateral.id)
		if (modalType === "collateralize") {
			return (
				<Collateralize
					visible={isOpen}
					exchange={exchange}
					collateral={collateral}
					onOk={async (body) => {
						await this.pledgXht(body);
					}}
					onPublic={() => null}
					onCancel={this.closeModal}
					onCollateralCallback={this.getData}
				/>
			);
		} else {
			return (
				<Pledge
					visible={isOpen}
					exchange={exchange}
					collateral={collateral}
					onOk={(body) => {
						this.pledgXht(body);
					}}
					amount={filterData.map(data => data.amount)}
					type={modalType}
					cancelData={filterData}
					getStakeAllData={this.getStakeAllData}
					onCancel={this.closeModal}
				/>
			);
		}
	};

	renderFormModal = () => {
		const { isOpenForm, type } = this.state;
		const { collateral } = this.props;
		if (!isOpenForm) return null;
		return (
			<ModalForm
				visible={isOpenForm}
				onCancel={() => {
					this.setState({ isOpenForm: false });
				}}
				onSubmit={(body) => {
					this.updateExchange(body, type);
				}}
				data={{ ...collateral.info.public }}
				type={type}
			/>
		);
	};

	render() {
		const { isFinish, msgs, isLoaded, isCreator } = this.state;
		const { collateral = {} } = this.props;

		if (!isLoaded) return null;

		// let height = 200;
		// if (this.flexBox) {
		// 	height =
		// 		window.innerWidth > 1200
		// 			? this.flexBox.offsetWidth / 4
		// 			: this.flexBox.offsetWidth / 2;
		// }

		const bannerStyle = {
			backgroundImage: pickRandomImage(collateral.id),
			// minHeight: `${height}px`
		};
		if (collateral.info && collateral.info.public && collateral.info.public.banner) {
			if (API_URL.includes('testnet') && (this.props && this.props.exchange && this.props.collateral && this.props.exchange.id !== this.props.collateral.id)) {
				bannerStyle.backgroundImage = `url(${EXCHANGE_S3_IMAGE('banner', collateral.name)})`
			} else {
				bannerStyle.backgroundImage = `url(${collateral.info.public.banner})`
			}
		}

		let country = getCountry(collateral.info, true);
		const public_title = collateral.info && collateral.info.public
			? collateral.info.public.name
				? collateral.info.public.name
				: collateral.info.public.title
			: '';
		const url = collateral.info && collateral.info.public
			? collateral.info.public.url &&
				collateral.info.public.url.indexOf('localhost') < 0 &&
				collateral.info.public.url.indexOf('example.com') < 0
				? collateral.info.public.url
				: undefined
			: undefined;
		const shareText = `${public_title} exchange project is open for crowd funding. Please visit @HollaEx. Check it out here:${window.location.href}`;
		return (
			<Wrapper>
				<div className="main-panel">
					<h2>{public_title}</h2>
					<div className="exchange-desc">
						{isCreator && (
							<span
								className="edit-info"
								onClick={() => {
									this.setState({ isOpenForm: true, type: 'info' });
								}}
							>
								Edit &nbsp;
								<Icon type="edit" />
							</span>
						)}
						{collateral.info && collateral.info.public && collateral.info.public.description}
					</div>
					<div className="flex-box" ref={this.setRef}>
						<div className="banner" style={bannerStyle}>
							{collateral.is_collateralized && <Flag />}
							{isCreator && (
								<span
									className="edit-banner"
									onClick={() => {
										this.setState({
											isOpenForm: true,
											type: 'banner'
										});
									}}
								>
									Edit &nbsp;
									<Icon type="edit" />
								</span>
							)}
						</div>
						<p className="info">
							{/* <span className="date">
									Estimated Launch: {returnDate(collateral.created_at)}
								</span> */}
							<div className="exchange-info">
								<div className="share-area">
									{collateral.is_featured && (
										<span className="featured">
											<Icon type="star" theme="filled" />
											Featured Project
										</span>
									)}
									<a
										className="twitter-share-button"
										target="_parent"
										onClick={() => {
											window.open(
												`https://twitter.com/intent/tweet?text=${shareText}`,
												'newwindow',
												'width=400,height=300'
											);
										}}
										href={window.href}
									>
										<Icon type="twitter" />
										Tweet
									</a>
									{country === '' ? (
										<span>
											<Icon
												type="global"
												style={{ fontSize: '11px', color: '#40A9FF' }}
											/>
											&nbsp;Global
										</span>
									) : (
										country
									)}
									{url && (
										<span>
											Website:&nbsp;
											<a href={url} title="url">
												{url}
											</a>
										</span>
									)}
									<label className="copy-link" onClick={this.copy}>
										<Icon type="copy" />
										Copy projects link
										<input
											readOnly
											value={`${window.location.origin}/project/${collateral.id}`}
										/>
									</label>
								</div>
							</div>
						</p>
					</div>
				</div>
				<div className="tabs">
					<Tabs defaultActiveKey="1" onChange={this.handleChangeTab}>
						<TabPane tab="About" key="1">
							{isCreator && (
								<span
									className="edit-pitch"
									onClick={() => {
										this.setState({
											isOpenForm: true,
											type: 'pitch'
										});
									}}
								>
									Edit &nbsp;
									<Icon type="edit" />
								</span>
							)}
							<div className="pitch-container">
								<h4>Unique Points</h4>
								<pre>
									{collateral.info && collateral.info.public && collateral.info.public.usp
										? collateral.info.public.usp
										: 'Empty'}
								</pre>
								<h4>Risk & Challenges</h4>
								<pre>
									{collateral.info && collateral.info.public &&
										collateral.info.public.risk
										? collateral.info.public.risk
										: 'Empty'}
								</pre>
								<h4>About Operator</h4>
								<pre>
									{collateral.info && collateral.info.public &&
										collateral.info.public.operator
										? collateral.info.public.operator
										: 'Empty'}
								</pre>
								<h4>Timeline</h4>
								<pre>
									{collateral.info && collateral.info.public &&
										collateral.info.public.timeline
										? collateral.info.public.timeline
										: 'Empty'}
								</pre>
							</div>
						</TabPane>
						<TabPane tab="Comments" key="2">
							<div className="msg-container tab-container">

								<Comments
									msgs={msgs}
									onSubmit={(body) => {
										this.postMessage(body);
									}}
									onDelete={(body) => {
										this.deleteMessage(body);
									}}
									showMore={() => {
										this.getMessage(this.state.id);
									}}
									isLoading={this.state.cmtIsLoading}
								/>

							</div>
						</TabPane>
					</Tabs>
				</div>

				<SuccessCollateralized
					visible={isFinish}
					onOk={this.hidePopup}
					onCancel={this.hidePopup}
				/>
				{this.renderPopup()}
				{this.renderFormModal()}
			</Wrapper>
		);
	}
}

export default Project;
